import { useRestClient } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'

export function useGetActivityLogByKeys({ entityGuid, templateKey }: { entityGuid: string; templateKey: string }) {
  const { getTemplatesApiGetTemplateLog } = useRestClient()
  const { appId, projectId } = useAppContext()

  return getTemplatesApiGetTemplateLog.useSuspenseQuery({
    query: { applicationId: appId!, projectId: projectId!, entityGuid, templateKey },
  })
}

export function useInvalidateActivityLogByKeys() {
  const { getTemplatesApiGetTemplateLog } = useRestClient()
  const { appId, projectId } = useAppContext()
  return () =>
    getTemplatesApiGetTemplateLog.invalidateQueries({
      parameters: {
        query: {
          applicationId: appId!,
          projectId: projectId!,
        },
      },
    })
}
